import { ID } from '@griply/types';

import { FirestoreInstance } from '../types/firestore';
import { FirestoreCollections } from '../types/firestore-collections';

export type DeleteSmartListOptions<
  TDocRef = unknown,
  TDb = FirestoreInstance,
> = {
  smartListId: ID;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  deleteDoc: (ref: NoInfer<TDocRef>) => Promise<void> | void;
  db: TDb;
};

export const deleteSmartList = async <TDocRef, TDb = FirestoreInstance>(
  options: DeleteSmartListOptions<TDocRef, TDb>,
): Promise<void> => {
  const { smartListId, doc, deleteDoc, db } = options;

  const ref = doc(db, FirestoreCollections.SmartLists, smartListId);
  await deleteDoc(ref);
};
